/*
 * Public API Surface of ngx-image-zoom
 */

export * from './lib/ngx-image-zoom.component';
export * from './lib/ngx-image-zoom.module';
